/* eslint-disable */
import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CTitle } from '../../components/Widget';
import ArrowImg from '../../../../../../assets/cybersecurity2026/finger.gif';
import { useUpdateComponentState } from '../../../hooks';
interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '5';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[4],
    [settings?.paragraphs]
  );
  // 添加状态来控制列表的可见项数量
  const [visibleItems, setVisibleItems] = useState(1);
  const [showArrowGif, setShowArrowGif] = useState(true);
  const updateComponentState = useUpdateComponentState();

  const handleFirstItemClick = () => {
    setShowArrowGif(false);
    if (visibleItems === 1 && paragraphsSettings?.l1List?.length) {
      let count = 1;
      const timer = setInterval(() => {
        count++;
        setVisibleItems(count);
        if (count >= paragraphsSettings.l1List.length) {
          clearInterval(timer);
          updateComponentState(
            p_course,
            p_topic,
            ID,
            'cybersecurity2026-topic1230pm-section4-1'
          );
        }
      }, 500);
    }
  };
  return (
    <div className="topic-section-4">
      <CTitle title={paragraphsSettings?.title} />
      {showArrowGif && <img className="arrow-gif" src={ArrowImg} alt="" />}
      <div className="phishing-fraud">
        <div
          className="phishing-fraud-list"
          id="cybersecurity2026-topic1230pm-section4-1"
        >
          {paragraphsSettings.l1List?.map((item: any, index: number) => {
            const isVisible = index < visibleItems;
            return (
              <div
                className={`phishing-fraud-item ${isVisible ? 'visible' : ''}`}
                key={item.title}
                onClick={index === 0 ? handleFirstItemClick : undefined}
                style={{
                  cursor: index === 0 ? 'pointer' : 'default',
                }}
              >
                <div className="title-style">{item.title}</div>
                <div className="con-style">{item.content}</div>
              </div>
            );
          })}
        </div>
        <div className="phishing-fraud-text">
          <div className="question-con">{paragraphsSettings.l1Tip}</div>
        </div>
      </div>
    </div>
  );
};

export default Section1;
